import { YearMonthUi } from './YearMonthUi';
import { useMonthSelectorSetter } from './useMonthSelectorSetter';

/**
 * A UI that lets you pick a date more easily by month/year.
 * Handles "end of month" and "start of month" logic.
 */
export const MonthSelector = ({ date, setDate, dateRangeEnd }) => {
  const set = useMonthSelectorSetter({ dateRangeEnd, setDate });

  return <YearMonthUi {...{ date, setDate: set }} />;
};
